import React, { useEffect, useState } from "react";
import AppNavbar from "../../components/common/AppNavbar";
import { fetchNewsByCategory } from "../../services/api";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";

function Health() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [healthData, setHealthData] = useState([]);
  const [error, setError] = useState(null);

  // Topic IDs for US Health API
  const topicIds = [530, 531, 532, 533, 534, 536, 537, 538, 539, 540, 541, 544];

  useEffect(() => {
    async function loadNews() {
      try {
        const data = await fetchNewsByCategory("health");
        setNews(data);
      } catch (err) {
        console.error("Error fetching health news:", err);
      } finally {
        setLoading(false);
      }
    }
    loadNews();
  }, []);

  useEffect(() => {
    const fetchHealthTopics = async () => {
      const topicsData = [];
      for (const topicId of topicIds) {
        try {
          const response = await axios.get(
            `https://health.gov/myhealthfinder/api/v3/topicsearch.json`,
            { params: { lang: "en", topicId, Type: "topic" } }
          );
          const topic = response.data.Result.Resources.Resource[0];
          if (topic) topicsData.push(topic);
        } catch (err) {
          console.error(`Error fetching topic ${topicId}:`, err);
        }
      }
      setHealthData(topicsData);
    };
    fetchHealthTopics();
  }, []);

  if (loading)
    return (
      <div className="text-center my-5">
        <Spinner animation="border" />
        <p>Loading...</p>
      </div>
    );

  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <AppNavbar />
      <div style={{ padding: "20px" }}>
        <div id="container">
          <NewsSection title="Health News" articles={news} category="health" />
        </div>
      </div>

      {/* <div style={{ backgroundColor: "#eeeeee", padding: "20px 0" }}>
        <Container className="col-lg-11">
          <h4 className="pt-3 ms-2 fw-bolder">US Health Topics</h4>
          {healthData.length > 0 ? (
            <Row className="g-3">
              {healthData.map((topic, index) => (
                <Col md={6} lg={3} key={index}>
                  <Card className="border-0 shadow">
                    <Card.Img variant="top" src={topic.ImageUrl} />
                    <Card.Body className="p-2" style={{ minHeight: "100px" }}>
                      <Card.Text>
                        <h6 className="fw-bold">{topic.Title}</h6>
                        <small>{topic.Categories}</small>
                      </Card.Text>
                      <div className="text-end">
                        <Link
                          to={`/health/${topic.Id}`}
                          className="btn btn-dark btn-sm"
                        >
                          Read More
                        </Link>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <p>Loading US health topics...</p>
          )}
        </Container>
      </div> */}
    </>
  );
}

export default Health;
